import { z } from "zod";

import { RedirectDtoSchema } from "../../../../dtos/redirects";

export const PluginRedirectSchema_2024_05_05 = RedirectDtoSchema;
export type PluginRedirectType_2024_05_05 = z.infer<
  typeof PluginRedirectSchema_2024_05_05
>;

export type PluginRedirectType = PluginRedirectType_2024_05_05;
